import { makeStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles'
import { Grid, Typography, Divider } from '@mui/material'
import useCheckbox from './hooks/useCheckbox'
import Checkbox from '../control/Checkbox'
import CheckboxGroup from '../control/CheckboxGroup'

type CheckboxPlaygroundType = ReturnType<typeof useCheckbox>

const CheckboxPlaygroundView = (props: CheckboxPlaygroundType) => {
    const { dataList, dataListGroup, checked, onClick, onClickForGroup } = props
    const classes = useStyles()

    return (
        <div>
            <Grid container>
                <Typography variant="h3" gutterBottom>
                    Control: Checkbox
                </Typography>
            </Grid>
            <Checkbox
                label={'Checked'}
                name={'checkbox'}
                checked={checked}
                onClick={onClick}
                overrideClass={{ root: classes.checkbox }}
            />
            <Checkbox
                label={'disabled'}
                name={'checkbox disabled'}
                checked={checked}
                onClick={onClick}
                labelPlacement={'bottom'}
                disabled
            />
            <br />
            <Divider style={{ width: '50%' }} />
            <br />
            <CheckboxGroup
                options={dataListGroup}
                label={'Control Group (horizontal)'}
                // name={'checkboxgroupA'}
                onClick={() => {}}
                // onClick={onClickForGroup}
                labelPlacement={'bottom'}
                overrideClass={{ root: classes.checkbox }}
            />
            <br />
            <br />
            <CheckboxGroup
                options={dataListGroup}
                label={'Control Group (vertical)'}
                // name={'checkboxgroupB'}
                onClick={() => {}}
                // onClick={onClickForGroup}
                alignment={'vertical'}
                overrideClass={{ root: classes.checkbox }}
            />
            <br />
            <br />
            <CheckboxGroup
                options={dataListGroup}
                label={'Control Group (required)'}
                // name={'checkboxgroup required'}
                onClick={() => {}}
                // onClick={onClickForGroup}
                overrideClass={{ root: classes.checkbox }}
                required
            />
            <br />
            <br />
            <CheckboxGroup
                options={dataListGroup}
                label={'Control Group (disabled)'}
                // name={'checkboxgroup disabled'}
                onClick={() => {}}
                // onClick={onClickForGroup}
                disabled
            />
        </div>
    )
}

//Controller
const CheckboxPlayground = () => {
    const checkboxModel = useCheckbox()
    return <CheckboxPlaygroundView {...checkboxModel} />
}

export default CheckboxPlayground

const useStyles = makeStyles((theme: Theme) => ({
    checkbox: {
        color: `${theme.palette.primary.main} !important`,
    },
}))
